import { render, staticRenderFns } from "./GuessComp.vue?vue&type=template&id=91960938&scoped=true&"
import script from "./GuessComp.vue?vue&type=script&lang=js&"
export * from "./GuessComp.vue?vue&type=script&lang=js&"
import style0 from "./GuessComp.vue?vue&type=style&index=0&id=91960938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91960938",
  null
  
)

export default component.exports